const getDataByName = (dataName, sdApi) => {
    // console.log(
    //   `dataname ${dataName}: sdApi.current.scene.getData(): ${JSON.stringify(
    //     sdApi.current.scene.getData()
    //   )} `
    // );
    const dataObj = sdApi.scene.getData().data[0];
    // console.log("data: ", JSON.stringify(dataObj.data[dataName]));
    // console.log(`dataObj.data[${dataName}]: `, dataObj.data[dataName]);
    if (dataObj) return dataObj.data[dataName];
    else {
      // console.log(
      //   `sdData.data[dataName]: ${JSON.stringify(sdData.data[dataName])}`
      // );
      console.log(`sdData.data[${dataName}]: `);
      // return sdData.data[dataName];
    }
  };

  export default getDataByName;